// TODO: axios baseURL
const URL = "/api/v1/gradebook/";

export const state = {
    lessonData: [],
};

export const getters = {
    lessonData: (state) => state.lessonData,
};

export const mutations = {
    setData(state, { type, items }) {
        state[type] = items;
    },

    clearData(state, { types }) {
        for (let key in state) {
            for (let type in types) {
                key === types[type] ? (state[key] = null) : false;
            }
        }
    },
};

export const actions = {
    async studentAbsences({ commit, dispatch }, params) {
        dispatch("loading/addLoading", "", { root: true });
        await axios.post(URL + "student-absences", params);
        dispatch("gradebook/gradebook/getTable", "", { root: true });
        dispatch("loading/subLoading", "", { root: true });
        commit("setData", { type: "modalStudentAbsences", items: false });
    },

    async changeScore({ commit, dispatch }, params) {
        try {
            dispatch("loading/addLoading", "", { root: true });
            await axios.post(URL + "change-score", params);
            dispatch("gradebook/gradebook/getTable", "", { root: true });
            dispatch("loading/subLoading", "", { root: true });
            commit("setData", { type: "modalStudentAbsences", items: false });
            return Promise.resolve();
        } catch (e) {
            return Promise.reject();
        }
    },

    async rejectFile({ dispatch }, params) {
        try {
            dispatch("loading/addLoading", "", { root: true });
            await axios.post(URL + "reject-file", params);
            dispatch("gradebook/gradebook/getTable", "", { root: true });
            dispatch("loading/subLoading", "", { root: true });
            // commit('setData', {type: 'modalStudentAbsences', items: false});
            return Promise.resolve();
        } catch (e) {
            return Promise.reject();
        }
    },

    hideModal({ commit }, modal) {
        commit("setData", { type: modal, items: false });
    },
};
